export const SHOW = 'show';
export const HIDE = 'hide';
export const GOALKEEPER_ID = 1;
export const DEFENDER_ID = 2;
export const MIDFIELDER_ID = 3;
export const FORWARD_ID = 4;
